import { TabPanel, TabView } from 'primereact/tabview';
import React, { useEffect, useState } from 'react';
import { Panel } from 'primereact/panel';
import { PayoutApprovalsTable } from '../../components/payoutApprovalsTable/PayoutApprovalsTable';
import { ScoreCardEds } from '../../components/scoreCardEds/ScoreCardEds';
import { ScoreCardFilter } from '../../components/scoreCardFilter/ScoreCardFilter';
import PrimaryApproval from '../../features/compensation/primaryApproval/PrimaryApproval';
import PrimaryApprovalDefault from '../../features/compensation/primaryApprovalDefault/PrimaryApprovalDefault';
import ScoreCardRoles from '../../features/compensation/scoreCardRoles/ScoreCardRoles';
import StatusDetail from '../../features/compensation/statusDetail/StatusDetail';
import ExportHistory from '../../features/compensation/exportHistory/ExportHistory';
import '../edsDashboard/edsDashboard.scss';
import { loadSCfilDate } from '../../utils/dateStorage';
import { ScorecardPizzaTracker } from '../../components/scorecardPizzaTracker/ScorecardPizzaTracker';

export const Compensation = () => {
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [hideScFilter, setHideScFilter] = useState<boolean>(false);
    const [inputMonth, setMonth] = useState(new Date().getMonth() + 1);
    const [inputYear, setYear] = useState(new Date().getFullYear());
    const [inputScorecardVersion, setInputScorecardVersion] = useState(0);
    const inputReadonly = false;

    const onScoreCardChange = (value: any) => {
        if (value !== undefined && value !== null && value !== '') {
            setMonth(value.month);
            setYear(value.year);
            setInputScorecardVersion(value.scorecardVersionId);
        }
    };

    useEffect(() => {
        const storedDate = loadSCfilDate();
        if (storedDate) {
            setMonth(storedDate.getMonth() + 1);
            setYear(storedDate.getFullYear());
        }
    }, []);
    return (
        <div>
            {!hideScFilter &&
                <ScoreCardFilter
                    menuName={'CompensationDashboard'}
                    scorecardData={onScoreCardChange}
                    filterSCValue={setInputScorecardVersion}
                    filterMonth={setMonth}
                    filterYear={setYear}
                />
            }
            { inputScorecardVersion > 0 &&
                <Panel
                    header="Scorecard Status"
                    toggleable
                    className="card mt-4 shadow bg-body rounded border-0"
                >
                    <ScorecardPizzaTracker
                        inputYear={inputYear}
                        inputMonth={inputMonth}
                        inputScorecardVersion={inputScorecardVersion}
                        fromCompensation
                    />
                </Panel>
            } 
           
            <div className="card mt-4">
                <TabView
                    activeIndex={activeIndex}
                    onTabChange={(event) => {
                        if (event.index === 6)
                            setHideScFilter(true);
                        else
                            setHideScFilter(false);

                        setActiveIndex(event.index);
                    }}>
                    <TabPanel header="Scorecard" leftIcon="scorecardTabBtnIcon">
                        <ScoreCardEds
                            inputMonth={inputMonth}
                            inputYear={inputYear}
                            inputScorecardVersion={inputScorecardVersion}
                        />
                    </TabPanel>
                    <TabPanel header="Payout Approval" leftIcon="payoutIcon">
                        <PayoutApprovalsTable
                            month={inputMonth}
                            year={inputYear}
                            scorecardversion={inputScorecardVersion}
                            ApprovalType="Compensation"
                        />
                    </TabPanel>
                    <TabPanel header="Primary Approval">
                        <PrimaryApproval
                            inputYear={inputYear}
                            inputMonth={inputMonth}
                            inputScorecardVersion={inputScorecardVersion}
                            inputReadonly={inputReadonly}
                        />
                    </TabPanel>
                    <TabPanel header="Defaults">
                        <PrimaryApprovalDefault
                            inputYear={inputYear}
                            inputMonth={inputMonth}
                            inputScorecardVersion={inputScorecardVersion}
                            inputReadonly={inputReadonly}
                        />
                    </TabPanel>
                    <TabPanel header="Scorecard Status">
                        <StatusDetail
                            inputYear={inputYear}
                            inputMonth={inputMonth}
                            inputScorecardVersion={inputScorecardVersion}
                        />
                    </TabPanel>
                    <TabPanel header="Scorecard Roles">
                        <ScoreCardRoles
                            inputYear={inputYear}
                            inputMonth={inputMonth}
                            inputScorecardVersion={inputScorecardVersion}
                        />
                    </TabPanel>
                    <TabPanel header="Export History">
                        <ExportHistory
                            yearInput={inputYear}
                            monthInput={inputMonth}
                        />
                    </TabPanel>
                </TabView>
            </div>
        </div>
    );
};
